import 'antd/dist/reset.css';
import './iconfont/iconfont.js';
import './app.global.less';
import './index.css';
import './variables.less';

// 适配深色主题的全局样式
document.body.style.backgroundColor = '#101217';
document.body.style.color = 'rgba(255, 255, 255, 0.85)';
